import { Form, Input } from 'antd';
import styled from 'styled-components';
import { classic } from '~/themes';

export const SFormItem = styled(Form.Item)<{ $lastItem?: boolean }>`
  .ant-form-item-explain-error {
    font-weight: 700;
  }
  margin-bottom: ${({ $lastItem }) => ($lastItem ? '0' : '20px')};

  @media screen and (max-height: 450px) {
    margin-bottom: ${({ $lastItem }) => ($lastItem ? '0' : '5px')};
  }
  @media screen and (max-width: 450px) {
    margin-bottom: ${({ $lastItem }) => ($lastItem ? '0' : '10px')};
  }
`;
//    min-width: 300px;
export const SInput = styled(Input)`
  &.ant-input-outlined {
    border-radius: 12px;
    border: 1px solid #eee;
    background: #fff;
    box-shadow: 0px -3px 4px 0px rgba(0, 0, 0, 0.25) inset;
    height: 46px;
    font-weight: 700;
  }
  @media screen and (max-height: 450px) {
    &.ant-input-outlined {
      height: 46px;
    }
  }
  @media screen and (max-width: 450px) {
    &.ant-input-outlined {
      height: 46px;
    }
  }

  &.ant-input-affix-wrapper {
    & > * {
      font-weight: 700 !important;
    }
  }

  .ant-input-affix-wrapper .ant-input {
    font-weight: 700 !important;
    & > * {
      font-weight: 700 !important;
    }
  }
`;

export const SSpanTitle = styled.h2<{
  $color?: string;
  $align?: string;
  $marginBottom?: string;
}>`
  color: ${({ $color }) => ($color ? $color : `${classic.token?.colorText}`)};
  font-family: 'Riffic Free', sans-serif;
  font-weight: 700;
  font-size: 1.7rem;
  margin-bottom: ${({ $marginBottom }) =>
    $marginBottom ? $marginBottom : '20px'};
  text-align: ${({ $align }) => ($align ? $align : 'left')};
  line-height: 1.25;
  user-select: none;
  @media screen and (max-height: 600px) {
    font-size: 1.3rem;
    margin-bottom: ${({ $marginBottom }) =>
      $marginBottom ? $marginBottom : '15px'};
  }
  @media screen and (max-height: 450px) {
    margin-bottom: 10px;
    font-size: 1.2rem;
    margin-bottom: ${({ $marginBottom }) =>
      $marginBottom ? $marginBottom : '10px'};
  }

  @media screen and (max-height: 440px) {
    margin-bottom: 10px;
    font-size: 1rem;
    margin-bottom: ${({ $marginBottom }) =>
      $marginBottom ? $marginBottom : '10px'};
  }
  @media screen and (max-width: 450px) {
    font-size: 1.25rem;
    margin-bottom: ${({ $marginBottom }) =>
      $marginBottom ? $marginBottom : '10px'};
  }
`;

export const SPFeedbackPosition = styled.p<{
  $color?: string;
  $align?: string;
  diff: number;
  $margin?: string;
}>`
  color: ${({ $color, diff }) => {
    if (diff > 0) return `${classic.token?.colorSuccess}`;
    if (diff < 0) return `${classic.token?.colorError}`;

    return $color ? $color : `${classic.token?.colorText}`;
  }};
  text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  -webkit-text-stroke-width: 0.8px;
  -webkit-text-stroke-color: #fff;

  font-family: 'Riffic Free', sans-serif;
  font-weight: 700;
  font-size: 1.7rem;
  margin: ${({ $margin }) => ($margin ? $margin : '0 20px')};
  text-align: ${({ $align }) => ($align ? $align : 'center')};
  user-select: none;
  @media screen and (max-height: 450px) {
    margin-bottom: 10px;
    font-size: 1.2rem;
  }
  @media screen and (max-width: 450px) {
    font-size: 1.5rem;
  }
`;

export const SSpanTextLg = styled.h2<{ $color?: string; $align?: string }>`
  color: ${({ $color }) => ($color ? $color : `${classic.token?.colorText}`)};
  font-family: 'Riffic Free', sans-serif;
  font-weight: 700;
  font-size: 1.3rem;
  margin-bottom: 20px;
  text-align: ${({ $align }) => ($align ? $align : 'left')};
  user-select: none;
  @media screen and (max-height: 600px) {
    font-size: 1.1rem;
  }
  @media screen and (max-height: 450px) {
    margin-bottom: 10px;
    font-size: 1rem;
  }
  @media screen and (max-width: 450px) {
    font-size: 1rem;
  }
`;

export const SSpanTitleSmall = styled.h3<{
  $color?: string;
  $marginBottom?: string;
  $bold?: boolean;
}>`
  color: ${({ $color }) => ($color ? $color : `${classic.token?.colorText}`)};
  font-family: 'Fira Sans', serif;
  font-weight: ${({ $bold }) => ($bold ? 'bold' : '400')};
  font-size: 1.3rem;
  user-select: none;
  text-transform: uppercase;
  text-align: center;
  margin-bottom: ${({ $marginBottom }) =>
    $marginBottom ? $marginBottom : '0'};

  @media screen and (max-height: 600px) {
    font-size: 1.1rem;
  }

  @media screen and (max-height: 450px) {
    font-size: 1rem;
  }
  @media screen and (max-width: 450px) {
    font-size: 0.9rem;
  }
`;

export const SSpanTitleExtraSmall = styled.h3<{
  $color?: string;
  $marginBottom?: string;
}>`
  color: ${({ $color }) => ($color ? $color : `${classic.token?.colorText}`)};
  font-family: 'Fira Sans', serif;
  font-weight: 400;
  font-size: 0.9rem;
  user-select: none;
  text-transform: uppercase;
  text-align: center;
  margin-bottom: ${({ $marginBottom }) =>
    $marginBottom ? $marginBottom : '0'};

  @media screen and (max-height: 450px) {
    font-size: 0.5rem;
  }
  @media screen and (max-width: 450px) {
    font-size: 0.5rem;
  }
`;

export const SSpanQcu = styled.span<{ $color?: string; $fontWeight?: string }>`
  color: ${({ $color }) => ($color ? $color : `${classic.token?.colorText}`)};
  font-family: 'Fira Sans', serif;
  font-weight: ${({ $fontWeight }) => ($fontWeight ? $fontWeight : '400')};
  font-size: 1.2rem;
  user-select: none;

  @media screen and (max-height: 450px) {
    font-size: 0.8rem;
  }
  @media screen and (max-width: 450px) {
    font-size: 0.8rem;
  }
`;

export const SSpan = styled.span<{ $color?: string; $textAlign?: string }>`
  color: ${({ $color }) =>
    $color ? $color : `${classic.token?.colorTextSecondary}`};
  font-family: 'Riffic Free', sans-serif;
  font-weight: 700;
  font-size: 1.25rem;
  text-align: ${({ $textAlign }) => ($textAlign ? $textAlign : 'left')};

  @media screen and (max-height: 800px) {
    font-size: 1.05rem;
  }

  @media screen and (max-width: 450px) {
    font-size: 1.05rem;
  }
`;

export const SSpanText = styled.span<{
  $color?: string;
  $textAlign?: string;
  $margin?: string;
}>`
  color: ${({ $color }) => ($color ? $color : `${classic.token?.colorText}`)};
  font-family: 'Fira Sans', serif;
  font-weight: 400;
  font-size: 1.1rem;
  text-align: ${({ $textAlign }) => ($textAlign ? $textAlign : 'left')};
  margin: ${({ $margin }) => ($margin ? $margin : '0')};

  @media screen and (max-height: 800px) {
    font-size: 1rem;
  }

  @media screen and (max-width: 450px) {
    font-size: 1rem;
  }
`;

export const SPText = styled.p<{
  $color?: string;
  $textAlign?: string;
  $margin?: string;
  $textDecoration?: string;
}>`
  color: ${({ $color }) => ($color ? $color : `${classic.token?.colorText}`)};
  font-family: 'Fira Sans', serif;
  font-weight: 400;
  font-size: 1.1rem;
  text-align: ${({ $textAlign }) => ($textAlign ? $textAlign : 'left')};
  margin: ${({ $margin }) => ($margin ? $margin : '0')};
  text-decoration: ${({ $textDecoration }) =>
    $textDecoration ? $textDecoration : 'none'};

  @media screen and (max-height: 800px) {
    font-size: 1rem;
  }

  @media screen and (max-width: 450px) {
    font-size: 1rem;
  }
  @media screen and (max-height: 450px) {
    font-size: 1rem;
  }
`;

export const SSpanTableName = styled.span`
  color: #113969;
  font-family: 'Riffic Free', sans-serif;
  font-weight: bold;
  font-size: 1.1rem;
  user-select: none;

  @media screen and (max-width: 450px) {
    font-size: 0.9rem;
  }
  @media screen and (max-width: 290px) {
    font-size: 0.8rem;
  }
  @media screen and (max-height: 600px) {
    font-size: 0.9rem;
  }
  @media screen and (max-height: 415px) {
    font-size: 0.8rem;
  }
  @media screen and (max-height: 290px) {
    font-size: 0.7rem;
  }
`;

export const SSpanTableAdvice = styled.span`
  color: #11396980;
  font-family: 'Fira Sans', serif;
  font-size: 0.9rem;
  font-weight: 400;
  user-select: none;

  @media screen and (max-width: 450px) {
    font-size: 0.8rem;
  }
  @media screen and (max-width: 290px) {
    font-size: 0.7rem;
  }
  @media screen and (max-height: 600px) {
    font-size: 0.8rem;
  }
  @media screen and (max-height: 450px) {
    font-size: 0.7rem;
  }
  @media screen and (max-height: 290px) {
    font-size: 0.6rem;
  }
`;

export const SDivRules = styled.div`
  left: 0;
  bottom: 0;
  position: absolute;
  width: 100%;
  pointer-events: none;
  z-index: 2;

  align-items: center;
  display: flex;
  justify-content: flex-end;
  min-height: 40px;
  padding: 5px;

  @media screen and (max-width: 450px) {
    padding: 5px;
  }
  @media screen and (max-height: 800px) {
    padding: 5px;
  }
  @media screen and (max-height: 450px) {
    padding: 5px;
  }
`;

export const SUl = styled.ul<{
  $color?: string;
  $textAlign?: string;
  $margin?: string;
}>`
  color: ${({ $color }) => ($color ? $color : `${classic.token?.colorText}`)};
  font-family: 'Fira Sans', serif;
  font-weight: 400;
  font-size: 1.1rem;
  text-align: ${({ $textAlign }) => ($textAlign ? $textAlign : 'left')};
  margin: ${({ $margin }) => ($margin ? $margin : '0')};

  @media screen and (max-height: 800px) {
    font-size: 1rem;
  }

  @media screen and (max-width: 450px) {
    font-size: 1rem;
  }
  @media screen and (max-height: 450px) {
    font-size: 1rem;
  }
  /* & > li {
    list-style: none;
  } */
`;
